
import React from 'react';
import { Provider } from 'react-redux';
import { store } from './Store/user';
import AppRoutes from './AppRoutes';
import './App.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;